import React from 'react';
import { CloseOutlined } from '@ant-design/icons';

export default function Index(props) {
  const { list = [], closeEvent = () => { }, type = '', preview = () => { }, edit = true } = props;
  return (
    <>
      {(list || []).length ? <div className='media-container'>
        {(list || []).map((item, index) => <div className='media-container-item' key={index}>
          {edit ? <CloseOutlined className='media-container-item-close' onClick={(e) => closeEvent(e, index)} /> : null}
          {(type === 'image') && <img className='port-quality-report-item-img' src={item.url} alt='' onClick={() => preview({ item: item.url, type: 'image' })} />}
          {(type === 'video') && <video className='port-quality-report-item-img' width="65" height="65" onClick={() => preview({ item: item.url.replace(/http:\/\//, 'https://'), type: 'video' })}><source src={item.url.replace(/http:\/\//, 'https://')} /></video>}
        </div>)}
      </div> : null}
    </>
  );
}
